'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setImmediate = require('./setImmediate');

var _setImmediate2 = _interopRequireDefault(_setImmediate);

var _reusableLazyPromise = require('./utils/reusableLazyPromise');

var _reusableLazyPromise2 = _interopRequireDefault(_reusableLazyPromise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var every = function every(fn) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var iterations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
  var rPromise = new _reusableLazyPromise2.default(function (res) {
    var timerID = setInterval(function (_) {
      return iterations-- > 0 ? fn() : rPromise.stop() & res();
    }, time);

    rPromise.stop = function (_) {
      return clearInterval(timerID);
    };
  });

  var rPromiseThen = function rPromiseThen() {
    return rPromise.then.apply(rPromise, arguments) && rPromise;
  };

  rPromise.done = rPromiseThen;
  rPromise.run = rPromiseThen;
  return rPromise;
};

exports.default = every;